/*!
 * Clara embed bundle for Shopify storefront.
 * Renders the Clara chat directly on the storefront so it does not depend on /embed/clara.
 */
(function () {
  var BUILD_MARKER = '2026-09-02-quiz-parent-r29';
  if (window.__claraEmbedLoaded) {
    try {
      document.querySelectorAll('.clara-panel,.clara-bubble,.clara-hint,#clara-embed-styles').forEach(function (el) { el.remove(); });
    } catch (e) { /* ignore */ }
  }
  window.__claraEmbedLoaded = true;
  window.__claraBuild = BUILD_MARKER;
  if (!window.__claraBuildLogged && window.console && console.log) {
    window.__claraBuildLogged = true;
    console.log('[Clara] build ' + BUILD_MARKER);
  }

  var script = document.currentScript;
  var ORIGIN = (script && script.getAttribute('data-embed-origin')) || 'https://practitioners.metabolics.com';
  var QUIZ_PATH = (window.__CLARA_PAGE && window.__CLARA_PAGE.quiz_path) || '/pages/what-supplements-should-i-take-free-60-second-quiz';
  var SUPABASE_URL = 'https://hscadcshumjwpbykirdu.supabase.co';
  var ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhzY2FkY3NodW1qd3BieWtpcmR1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc2MTUyMDYsImV4cCI6MjA3MzE5MTIwNn0.bT-A3BJzHNXAhUuT__L7Iqf6p0FTjjP82MIdFZdVYb0';
  var CHAT_URL = SUPABASE_URL + '/functions/v1/clara-public-chat';
  var TRACK_URL = window.__CLARA_TRACK_URL || (SUPABASE_URL + '/functions/v1/clara-public-track');
  var TRANSCRIBE_URL = SUPABASE_URL + '/functions/v1/voice-transcribe';
  var avatarUrl = ORIGIN.replace(/\/$/, '') + '/images/clara-avatar.jpg';
  var messages = [];
  var replyOptions = [];
  var conversationId;
  var loading = false;

  var panelEl, bubbleEl, hintEl, messagesEl, inputEl, clearBtn, micBtn, orderObserver;
  var tabsEl, quickEl;
  var activeTab = 'subscriptions';
  var mediaRecorder = null;
  var mediaChunks = [];
  var mediaStream = null;
  var isRecording = false;
  var isTranscribing = false;
  // Pristine XHR/fetch refs captured before any third-party script can patch
  // them. Shopify's customer-account script (which only loads when the
  // shopper is signed in) monkey-patches both window.fetch and
  // window.XMLHttpRequest, mangling our response. We hold an unmodified
  // reference here as a fallback.
  var NativeXHR = window.XMLHttpRequest;
  var NativeFetch = window.fetch && window.fetch.bind(window);
  // A hidden same-origin iframe gives us a guaranteed clean XHR/fetch even
  // if our top-level captures above were already overridden by the time
  // this script ran.
  var sandboxFrame = null;
  function ensureSandbox() {
    if (sandboxFrame && sandboxFrame.contentWindow) return;
    try {
      var f = document.createElement('iframe');
      f.setAttribute('aria-hidden', 'true');
      f.setAttribute('title', 'clara-sandbox');
      f.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;left:-9999px';
      f.src = 'about:blank';
      (document.body || document.documentElement).appendChild(f);
      sandboxFrame = f;
    } catch (e) { /* ignore */ }
  }
  function sandboxXHR() {
    try {
      if (sandboxFrame && sandboxFrame.contentWindow && sandboxFrame.contentWindow.XMLHttpRequest) {
        return new sandboxFrame.contentWindow.XMLHttpRequest();
      }
    } catch (e) { /* ignore */ }
    return new NativeXHR();
  }

  // Identity switching (log out, log in as someone else) must start a fresh
  // tracking session, otherwise the new shopper inherits the previous
  // customer's verified session server-side.
  function identityKey(who) {
    if (!who) return 'anon';
    return String(who.email || '').toLowerCase() + '|' + String(who.id || '');
  }
  function newId() {
    return crypto && crypto.randomUUID ? crypto.randomUUID() : 'anon-' + Date.now() + '-' + Math.random().toString(36).slice(2);
  }
  function anonId() {
    try {
      var id = localStorage.getItem('clara_anon_id') || localStorage.getItem('clara_public_anon_id');
      if (!id) id = newId();
      // Older builds could leave these keys pointing at different sessions.
      // Always converge them before chat or the quiz consumes the identifier.
      localStorage.setItem('clara_anon_id', id);
      localStorage.setItem('clara_public_anon_id', id);
      return id;
    } catch (e) {
      return null;
    }
  }
  function syncAnonIdToIdentity(who) {
    try {
      var key = identityKey(who);
      var seen = localStorage.getItem('clara_identity_key');
      if (seen === key) return;
      localStorage.setItem('clara_identity_key', key);
      if (seen === null) return; // first run: keep the existing session
      var fresh = newId();
      localStorage.setItem('clara_anon_id', fresh);
      localStorage.setItem('clara_public_anon_id', fresh);
    } catch (e) { /* ignore */ }
  }

  // The page the visitor is on, forwarded with every chat turn so unqualified
  // questions ("what are the benefits?") resolve to the product on screen.
  // Never relies on the theme Liquid alone: falls back to Shopify analytics
  // meta, then to the URL path and page metadata, so a stale theme still works.
  function metaContent(selector) {
    try {
      var el = document.querySelector(selector);
      return (el && (el.getAttribute('content') || el.getAttribute('href'))) || '';
    } catch (e) { return ''; }
  }
  function pathHandles() {
    var path = '';
    try { path = location.pathname || ''; } catch (e) { path = ''; }
    var prod = path.match(/\/products\/([^/?#]+)/);
    var coll = path.match(/\/collections\/([^/?#]+)/);
    return {
      product: prod ? decodeURIComponent(prod[1]) : '',
      collection: coll && coll[1] !== 'all' ? decodeURIComponent(coll[1]) : ''
    };
  }
  function pageContext() {
    var p = window.__CLARA_PAGE || {};
    var sa = null;
    try { sa = window.ShopifyAnalytics && window.ShopifyAnalytics.meta; } catch (e) { sa = null; }
    var fromPath = pathHandles();
    var handle = p.product_handle || (sa && sa.product && sa.product.handle) || fromPath.product || '';
    var title = p.product_title || '';
    if (!title && sa && sa.product && sa.product.variants && sa.product.variants[0]) {
      title = sa.product.variants[0].name || '';
    }
    if (!title && handle) {
      title = metaContent('meta[property="og:title"]') || '';
      if (!title) {
        try {
          var h1 = document.querySelector('h1');
          title = (h1 && h1.textContent && h1.textContent.trim()) || '';
        } catch (e) { /* ignore */ }
      }
    }
    var collectionHandle = p.collection_handle || fromPath.collection || '';
    var template = p.template || (sa && sa.page && sa.page.pageType) || '';
    if (!template) {
      if (handle) template = 'product';
      else if (collectionHandle) template = 'collection';
    }
    var ctx = {
      template: template,
      product_title: title,
      product_handle: handle,
      product_type: p.product_type || (sa && sa.product && sa.product.type) || '',
      product_url: p.product_url || metaContent('link[rel="canonical"]') || (handle ? location.origin + '/products/' + handle : ''),
      product_price: p.product_price || '',
      collection_title: p.collection_title || '',
      collection_handle: collectionHandle
    };
    try { window.__claraPage = ctx; } catch (e) { /* ignore */ }
    return ctx;
  }


  function context() {
    var ctx = { referrer: document.referrer || location.href };
    try {
      var sa = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (sa) {
        ctx.page_type = sa.page && sa.page.pageType;
        ctx.product_handle = sa.product && sa.product.handle;
        ctx.product_id = sa.product && sa.product.id;
      }
      if (window.Shopify && window.Shopify.shop) ctx.shop = window.Shopify.shop;
      if (window.__CLARA_SHOPIFY) ctx.shopify = window.__CLARA_SHOPIFY;
    } catch (e) {}
    return ctx;
  }

  // Resolve the logged-in Shopify customer from every source the storefront
  // exposes. Themes with new customer accounts (or cached Liquid) often leave
  // window.ClaraConfig empty while the analytics globals still know the id.
  function claraIdentity() {
    var email = null, firstName = null, id = null;
    try {
      var cfg = window.ClaraConfig || {};
      var sh = window.__CLARA_SHOPIFY || {};
      email = cfg.customerEmail || sh.customer_email || null;
      firstName = cfg.customerFirstName || sh.customer_first_name || null;
      id = cfg.customerId || sh.customer_id || null;
      if (!id && window.__st && window.__st.cid) id = String(window.__st.cid);
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (!id && meta && meta.page && meta.page.customerId) id = String(meta.page.customerId);
      if (!id && window.Shopify && window.Shopify.customerId) id = String(window.Shopify.customerId);
      // Remember the strongest identity we have seen this browser session so a
      // cached page render cannot downgrade a signed-in visitor to anonymous.
      // A server-rendered ClaraConfig with no customer is authoritative proof
      // that the visitor signed out, so the cache must be cleared then.
      var stored = null;
      try { stored = JSON.parse(localStorage.getItem('clara_identity') || 'null'); } catch (e) {}
      var serverRendered = !!(window.ClaraConfig || window.__CLARA_SHOPIFY);
      if (email || id) {
        try {
          localStorage.setItem('clara_identity', JSON.stringify({ email: email, first_name: firstName, id: id }));
        } catch (e) {}
      } else if (serverRendered) {
        try { localStorage.removeItem('clara_identity'); } catch (e) {}
      } else if (stored && (stored.email || stored.id)) {
        email = stored.email || null;
        firstName = stored.first_name || null;
        id = stored.id || null;
      }
    } catch (e) {}
    var who = (email || id) ? { email: email, first_name: firstName, id: id === null || id === undefined ? null : String(id) } : null;
    syncAnonIdToIdentity(who);
    return who;
  }
  // The quiz must consume the exact same identity and browser session as chat.
  window.__claraIdentity = claraIdentity;
  window.__claraAnonId = anonId;

  function track(eventType, payload) {
    if (!TRACK_URL) return;
    var body = JSON.stringify({
      event_type: eventType,
      anon_id: anonId(),
      conversation_id: conversationId,
      payload: Object.assign({}, context(), payload || {}),
      shopify_customer: claraIdentity(),

      referrer: location.href,
    });
    try {
      if (navigator.sendBeacon && eventType !== 'thumbs_up' && eventType !== 'thumbs_down') {
        navigator.sendBeacon(TRACK_URL, body);
      } else {
        fetch(TRACK_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', apikey: ANON_KEY, Authorization: 'Bearer ' + ANON_KEY },
          body: body,
          keepalive: true,
        });
      }
    } catch (e) {}
  }

  function esc(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch];
    });
  }

  function setMicState() {
    if (!micBtn) return;
    micBtn.classList.toggle('clara-mic-recording', isRecording);
    micBtn.disabled = isTranscribing;
    micBtn.setAttribute('aria-label', isRecording ? 'Stop recording' : (isTranscribing ? 'Transcribing...' : 'Voice input'));
    micBtn.title = isRecording ? 'Tap to stop' : (isTranscribing ? 'Transcribing...' : 'Voice input');
  }

  function toggleRecording() {
    if (isTranscribing) return;
    if (isRecording) { stopRecording(); } else { startRecording(); }
  }

  function startRecording() {
    if (!navigator.mediaDevices || !window.MediaRecorder) {
      alert('Voice input is not supported in this browser.');
      return;
    }
    navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true } })
      .then(function (stream) {
        mediaStream = stream;
        var mime = 'audio/webm;codecs=opus';
        try { mediaRecorder = new MediaRecorder(stream, { mimeType: mime }); }
        catch (e) { mediaRecorder = new MediaRecorder(stream); }
        mediaChunks = [];
        mediaRecorder.ondataavailable = function (ev) { if (ev.data && ev.data.size > 0) mediaChunks.push(ev.data); };
        mediaRecorder.onstop = function () { handleRecordingStop(); };
        mediaRecorder.start();
        isRecording = true;
        setMicState();
        if (inputEl) inputEl.placeholder = 'Listening... tap mic to stop';
      })
      .catch(function (err) {
        console.error('mic error', err);
        alert('Microphone access was blocked. Please enable mic permissions and try again.');
      });
  }

  function stopRecording() {
    if (mediaRecorder && mediaRecorder.state === 'recording') {
      try { mediaRecorder.stop(); } catch (e) {}
    }
    if (mediaStream) {
      try { mediaStream.getTracks().forEach(function (t) { t.stop(); }); } catch (e) {}
    }
    isRecording = false;
    setMicState();
  }

  function handleRecordingStop() {
    isTranscribing = true;
    setMicState();
    if (inputEl) inputEl.placeholder = 'Transcribing...';
    var blob = new Blob(mediaChunks, { type: 'audio/webm' });
    mediaChunks = [];
    var reader = new FileReader();
    reader.onloadend = function () {
      var dataUrl = String(reader.result || '');
      var base64 = dataUrl.split(',')[1];
      if (!base64) { isTranscribing = false; setMicState(); return; }
      fetch(TRANSCRIBE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', apikey: ANON_KEY, Authorization: 'Bearer ' + ANON_KEY },
        body: JSON.stringify({ audio: base64 }),
      })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (data) {
          if (data && data.text) {
            if (inputEl) {
              var existing = inputEl.value || '';
              inputEl.value = existing ? (existing.replace(/\s+$/, '') + ' ' + data.text) : data.text;
              inputEl.focus();
            }
            track('voice_transcribed', { length: String(data.text).length });
          } else {
            console.warn('No transcription', data);
          }
        })
        .catch(function (err) { console.error('transcribe failed', err); })
        .finally(function () {
          isTranscribing = false;
          setMicState();
          if (inputEl) inputEl.placeholder = 'Ask Clara anything...';
        });
    };
    reader.readAsDataURL(blob);
  }

  function markdown(text) {
    return esc(text)
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>')
      .replace(/\n/g, '<br>');
  }

  // Pull action links (markdown links and bare URLs) out of an assistant
  // message so they can be rendered as buttons underneath the bubble.
  function extractLinks(text) {
    var links = [];
    var clean = String(text || '').replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, function (m, label, url) {
      links.push({ label: label, url: url });
      return '';
    }).replace(/(https?:\/\/[^\s)]+)/g, function (m, url) {
      links.push({ label: 'Open link', url: url });
      return '';
    });
    clean = clean.replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
    return { text: clean, links: links };
  }


  // Page-aware conversation starters. Liquid supplies these via
  // window.__CLARA_PAGE.starters; if that is missing we derive them from the
  // Shopify template so older themes still get relevant prompts.
  var STARTERS_HOME = ['Which products are right for me?', 'Find a practitioner near me', 'Where is my order?', 'What is your return and refund policy?', 'How do I apply a discount code?', 'How can I manage my subscription?'];
  var STARTER_LIMIT = 6;
  function derivedStarters() {
    var page = window.__CLARA_PAGE || {};
    var tpl = String(page.template || (window.__CLARA_SHOPIFY && window.__CLARA_SHOPIFY.template) || '');
    var title = page.product_title || '';
    var collection = page.collection_title || '';
    if (tpl.indexOf('cart') === 0 || tpl.indexOf('checkout') === 0) return [];
    if (title) {
      return ['What are the benefits?', 'What are the ingredients?', 'How many should I take a day?', 'How many servings are there?'];
    }
    if (collection) {
      return ['Help me choose from ' + collection, 'Compare products in ' + collection, 'Which one suits my goal?', 'Any interactions to know about?'];
    }
    if (tpl.indexOf('article') === 0 || tpl.indexOf('blog') === 0 || tpl.indexOf('page') === 0) {
      return ['Explain this in plain English', 'Which products relate to this?', 'Which products are right for me?', 'Find a practitioner near me', 'Where is my order?', 'What is your return and refund policy?'];
    }
    if (tpl.indexOf('customers/') === 0) {
      return ['Where is my order?', 'How can I manage my subscription?', 'Start a return', 'What is your return and refund policy?', 'How do I apply a discount code?', 'Find a practitioner near me'];
    }
    return STARTERS_HOME.slice();
  }
  var STARTER_STOP = ['a','an','and','are','can','choose','do','for','from','help','i','in','is','it','me','my','of','on','options','or','products','should','show','take','tell','that','the','these','this','to','what','whats','which','with','you','your'];
  function starterTokens(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9\s]/g, ' ').split(/\s+/).filter(function (w) { return w && STARTER_STOP.indexOf(w) === -1; });
  }
  function nearDuplicateStarter(a, b) {
    var ta = starterTokens(a), tb = starterTokens(b);
    if (!ta.length || !tb.length) return String(a).toLowerCase() === String(b).toLowerCase();
    var shared = 0;
    for (var i = 0; i < ta.length; i++) if (tb.indexOf(ta[i]) !== -1 && ta.indexOf(ta[i]) === i) shared++;
    var ua = ta.filter(function (v, i) { return ta.indexOf(v) === i; }).length;
    var ub = tb.filter(function (v, i) { return tb.indexOf(v) === i; }).length;
    return shared / Math.max(ua, ub) >= 0.7;
  }
  function dedupeStarters(list) {
    var out = [];
    (list || []).forEach(function (item) {
      if (!item) return;
      for (var i = 0; i < out.length; i++) if (nearDuplicateStarter(out[i], item)) return;
      out.push(item);
    });
    return out;
  }
  function cleanStarter(value) {
    return String(value || '').replace(/supplement stack/gi, 'supplement protocol');
  }
  var starters = (function () {
    var page = window.__CLARA_PAGE || {};
    if (Array.isArray(page.starters)) return dedupeStarters(page.starters.filter(Boolean).map(cleanStarter)).slice(0, STARTER_LIMIT);
    return dedupeStarters(derivedStarters().map(cleanStarter)).slice(0, STARTER_LIMIT);
  })();

  // Personalised refresh: recent orders and prior intents can replace the
  // page-type starters. Never runs on cart or checkout, where we show none.
  function refreshStarters() {
    var page = window.__CLARA_PAGE || {};
    var tpl = String(page.template || '');
    if (!starters.length || tpl.indexOf('cart') === 0 || tpl.indexOf('checkout') === 0) return;
    var anonId = null;
    try { anonId = localStorage.getItem('clara_anon_id') || localStorage.getItem('clara_public_anon_id'); } catch (e) {}
    try {
      fetch(SUPABASE_URL + '/functions/v1/clara-hero-suggest', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          anon_id: anonId,
          page: {
            template: page.template || '',
            product_title: page.product_title || '',
            product_type: page.product_type || '',
            collection_title: page.collection_title || ''
          },
          customer: { logged_in: !!(window.__CLARA_SHOPIFY && window.__CLARA_SHOPIFY.customer_id) },
          recent_titles: [],
          defaults: starters
        })
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data.chips || !data.chips.length) return;
          starters = dedupeStarters(data.chips.map(function (c) { return cleanStarter(typeof c === 'string' ? c : (c.seed || c.label)); }).filter(Boolean)).slice(0, STARTER_LIMIT);
          if (!messages.length) renderMessages();
        })
        .catch(function () { /* keep page starters */ });
    } catch (e) { /* keep page starters */ }
  }

  var QUICK_REPLIES = {
    subscriptions: ['Pause my subscription', 'Skip next delivery', 'Change delivery frequency', 'Cancel my subscription'],
    returns: ['Start a return', 'Damaged or faulty item', 'Wrong item received', 'Return policy', 'Check refund status'],
    tracking: ['Where is my order?', 'Update delivery address', 'Delivery times', 'My parcel is missing']
  };
  function renderQuickReplies() {
    if (!quickEl) return;
    var opts = QUICK_REPLIES[activeTab] || [];
    quickEl.innerHTML = opts.map(function (o) {
      return '<button type="button" data-clara-quick="' + esc(o) + '">' + esc(o) + '</button>';
    }).join('');
  }

  function renderMessages() {
    if (!messagesEl) return;
    if (tabsEl) {
      Array.prototype.forEach.call(tabsEl.querySelectorAll('button[data-clara-tab]'), function (b) {
        b.classList.toggle('clara-tab-active', b.getAttribute('data-clara-tab') === activeTab);
      });
    }
    var html = '';
    if (!messages.length) {
      html += '<div class="clara-empty">' +
        '<img src="' + avatarUrl + '" alt="Clara" class="clara-empty-avatar" />' +
        '<h3>Hey, I\'m Clara</h3>' +
        '<p>I can help you find Metabolics supplements, explain ingredients, compare products, and answer general nutrition questions.</p>' +
        (starters.length
          ? '<div class="clara-suggestions">' +
              starters.map(function (s) {
                return '<button type="button" data-clara-suggestion="' + esc(s) + '">' + esc(s) + '</button>';
              }).join('') +
            '</div>'
          : '') +
      '</div>';
    } else {
      html += messages.map(function (msg, index) {
        if (msg.role === 'user') {
          return '<div class="clara-row clara-row-user"><div class="clara-msg clara-msg-user">' + esc(msg.content) + '</div></div>';
        }
        var parsed = extractLinks(msg.content);
        var actionsHtml = parsed.links.length
          ? '<div class="clara-actions">' + parsed.links.map(function (l) {
              return '<a class="clara-action-btn" href="' + esc(l.url) + '" target="_blank" rel="noopener noreferrer">' + esc(l.label) + '</a>';
            }).join('') + '</div>'
          : '';
        return '<div class="clara-row clara-row-assistant"><img src="' + avatarUrl + '" alt="" class="clara-msg-avatar" />' +
          '<div><div class="clara-msg clara-msg-assistant">' + markdown(parsed.text) + '</div>' +
          actionsHtml +
          '<div class="clara-feedback"><button type="button" data-clara-feedback="up" data-index="' + index + '" aria-label="Helpful">👍</button><button type="button" data-clara-feedback="down" data-index="' + index + '" aria-label="Not helpful">👎</button></div></div></div>';
      }).join('');
    }
    if (!loading && replyOptions.length) {
      html += '<div class="clara-options">' +
        replyOptions.map(function (o) {
          return '<button type="button" data-clara-option="' + esc(o.value) + '">' + esc(o.label) + '</button>';
        }).join('') +
      '</div>';
    }
    if (loading) {
      html += '<div class="clara-row clara-row-assistant"><img src="' + avatarUrl + '" alt="" class="clara-msg-avatar" /><div class="clara-msg clara-msg-assistant clara-typing"><span></span><span></span><span></span></div></div>';
    }

    messagesEl.innerHTML = html;
    messagesEl.scrollTop = messagesEl.scrollHeight;
    if (clearBtn) clearBtn.style.display = messages.length ? '' : 'none';
  }

  function isMobileView() {
    return !!(window.matchMedia && window.matchMedia('(max-width:640px)').matches);
  }

  var origViewportContent = null;
  var vvHandler = null;

  // Keep the full-screen mobile panel glued to the visual viewport so the
  // on-screen keyboard never leaves a gap or pushes the input bar around.
  function applyKeyboardHandling(enable) {
    var meta = document.querySelector('meta[name="viewport"]');
    if (enable) {
      if (meta && origViewportContent === null) {
        origViewportContent = meta.getAttribute('content') || '';
        if (origViewportContent.indexOf('interactive-widget') === -1) {
          meta.setAttribute('content', origViewportContent + ', interactive-widget=resizes-content');
        }
      }
      if (window.visualViewport && !vvHandler) {
        vvHandler = function () {
          if (!panelEl || panelEl.style.display === 'none' || !isMobileView()) return;
          var vv = window.visualViewport;
          var kbOpen = vv.height < window.innerHeight * 0.75;
          panelEl.classList.toggle('clara-kb-open', kbOpen);
          if (kbOpen) {
            panelEl.style.top = vv.offsetTop + 'px';
            panelEl.style.height = vv.height + 'px';
          } else {
            panelEl.style.top = '';
            panelEl.style.height = '';
          }
          if (messagesEl) messagesEl.scrollTop = messagesEl.scrollHeight;
        };
        window.visualViewport.addEventListener('resize', vvHandler);
        window.visualViewport.addEventListener('scroll', vvHandler);
      }
    } else {
      if (meta && origViewportContent !== null) {
        meta.setAttribute('content', origViewportContent);
        origViewportContent = null;
      }
      if (window.visualViewport && vvHandler) {
        window.visualViewport.removeEventListener('resize', vvHandler);
        window.visualViewport.removeEventListener('scroll', vvHandler);
        vvHandler = null;
      }
      if (panelEl) {
        panelEl.classList.remove('clara-kb-open');
        panelEl.style.top = '';
        panelEl.style.height = '';
      }
    }
  }

  function setOpen(open, fullscreen) {
    ensurePanel();
    var mobile = isMobileView();
    panelEl.style.display = open ? 'flex' : 'none';
    bubbleEl.style.display = open ? 'none' : 'inline-flex';
    panelEl.classList.toggle('clara-panel-full', !!(open && (fullscreen || mobile)));
    enforceInputBeforeQuiz();
    if (hintEl) hintEl.style.display = 'none';
    applyKeyboardHandling(!!open);
    if (open) {
      renderMessages();
      renderQuickReplies();
      enforceInputBeforeQuiz();
      // Don't autofocus on mobile: it pops the keyboard over a fresh empty chat.
      setTimeout(function () { if (inputEl && !mobile) inputEl.focus(); }, 60);
      track('overlay_opened', { surface: 'bubble' });
    }
  }

  function send(text, surface) {
    var trimmed = String(text || '').trim();
    if (!trimmed || loading) return;
    messages.push({ role: 'user', content: trimmed });
    replyOptions = [];

    if (inputEl) inputEl.value = '';
    loading = true;
    renderMessages();
    // Silent auth: forward the Supabase user token if a session is present in
    // this origin's localStorage (e.g. embed loaded inside practitioners.metabolics.com).
    var headers = { 'Content-Type': 'application/json', apikey: ANON_KEY, Authorization: 'Bearer ' + ANON_KEY };
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (k && /^sb-.*-auth-token$/.test(k)) {
          var raw = localStorage.getItem(k);
          if (!raw) continue;
          var parsed = JSON.parse(raw);
          var token = parsed && (parsed.access_token || (parsed.currentSession && parsed.currentSession.access_token));
          if (token) { headers['x-user-token'] = token; break; }
        }
      }
    } catch (e) { /* ignore */ }
    // Soft auth for Shopify storefront: theme exposes the logged-in
    // customer's email via window.ClaraConfig. Forward as an unsigned hint
    // so Clara can greet them and skip OTP after a soft confirmation.
    var shopifyCustomer = claraIdentity();
    try {
      if (shopifyCustomer) {
        if (shopifyCustomer.email) {
          headers['x-shopify-customer-email-hint'] = String(shopifyCustomer.email);
          if (shopifyCustomer.first_name) headers['x-shopify-customer-name-hint'] = String(shopifyCustomer.first_name);
        }
        if (shopifyCustomer.id) headers['x-shopify-customer-id-hint'] = String(shopifyCustomer.id);
      }
    } catch (e) { /* ignore */ }

    // Use a clean XMLHttpRequest pulled from a long-lived hidden same-origin
    // iframe so Shopify's customer-account script (logged-in only) cannot
    // intercept the response.
    ensureSandbox();
    var payload = JSON.stringify({
      messages: messages.map(function (m) { return { role: m.role, content: m.content }; }),
      conversation_id: conversationId,
      anon_id: anonId(),
      referrer: location.href,
      surface: surface || 'bubble',
      page: pageContext(),
      shopify_customer: shopifyCustomer,
    });
    var xhrPromise = new Promise(function (resolve, reject) {
      try {
        var xhr = sandboxXHR();
        xhr.open('POST', CHAT_URL, true);
        Object.keys(headers).forEach(function (k) { xhr.setRequestHeader(k, headers[k]); });
        xhr.onload = function () {
          var txt = xhr.responseText || '';
          var data = {};
          try { data = txt ? JSON.parse(txt) : {}; } catch (e) { data = { error: txt || 'Clara could not reply' }; }
          if (xhr.status < 200 || xhr.status >= 300) {
            reject(new Error((data && data.error) || 'Clara could not reply'));
          } else {
            resolve(data);
          }
        };
        xhr.onerror = function () { reject(new Error('xhr_failed')); };
        xhr.send(payload);
      } catch (e) { reject(e); }
    });
    // If the sandbox XHR errors out (e.g. iframe not ready, browser quirks),
    // retry with a captured native fetch as a fallback.
    xhrPromise = xhrPromise.catch(function (err) {
      if (!NativeFetch || (err && err.message && err.message !== 'xhr_failed' && err.message !== 'Network error')) {
        throw err;
      }
      return NativeFetch(CHAT_URL, { method: 'POST', headers: headers, body: payload, mode: 'cors', credentials: 'omit' })
        .then(function (r) { return r.text().then(function (t) { return { ok: r.ok, status: r.status, text: t }; }); })
        .then(function (resp) {
          var data = {};
          try { data = resp.text ? JSON.parse(resp.text) : {}; } catch (e) { data = { error: resp.text || 'Clara could not reply' }; }
          if (!resp.ok) throw new Error((data && data.error) || 'Clara could not reply');
          return data;
        });
    });
    function performAddToCart(variantId, quantity, sellingPlanId, fallbackUrl) {
      function openCartDrawer() {
        try { document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true })); } catch (e) {}
        try { document.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true })); } catch (e) {}
        var selectors = [
          '#cart-icon-bubble',
          '[data-cart-trigger]',
          '[data-drawer-trigger="cart"]',
          '[data-drawer-id="cart-drawer"]',
          'a[href="/cart"]',
          '.header__icon--cart',
          '.cart-icon',
          '.icon-cart',
          '[data-action="open-drawer"][data-drawer-id*="cart"]'
        ];
        for (var i = 0; i < selectors.length; i++) {
          var el = document.querySelector(selectors[i]);
          if (el) { try { el.click(); } catch (e) {} return true; }
        }
        return false;
      }
      var item = { id: String(variantId), quantity: Number(quantity) || 1 };
      if (sellingPlanId) item.selling_plan = String(sellingPlanId);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add_failed');
          return r.json().catch(function () { return {}; });
        })
        .then(function () {
          setOpen(false);
          window.setTimeout(function () {
            if (!openCartDrawer() && fallbackUrl) {
              window.location.href = fallbackUrl;
            }
          }, 150);
        })
        .catch(function () {
          if (fallbackUrl) window.location.href = fallbackUrl;
        });
    }

    xhrPromise
      .then(function (data) {
        conversationId = data.conversation_id;
        if (data.anon_id) {
          try {
            localStorage.setItem('clara_anon_id', data.anon_id);
            localStorage.setItem('clara_public_anon_id', data.anon_id);
          } catch (e) {}
        }
        messages.push({ role: 'assistant', content: data.message || '' });
        replyOptions = Array.isArray(data.reply_options)
          ? data.reply_options.map(function (o) {
              if (typeof o === 'string') return { label: o, value: o };
              return { label: String((o && (o.label || o.value)) || ''), value: String((o && (o.value || o.label)) || '') };
            }).filter(function (o) { return o.label && o.value; }).slice(0, 8)
          : [];
        if (data.add_to_cart && data.add_to_cart.variant_id) {
          performAddToCart(data.add_to_cart.variant_id, data.add_to_cart.quantity, data.add_to_cart.selling_plan_id, data.checkout_url);
        }
      })
      .catch(function (err) { messages.push({ role: 'assistant', content: (err && err.message) || 'Sorry, something went wrong. Please try again.' }); })
      .finally(function () { loading = false; renderMessages(); });
  }

  var CLARA_LUXE_CSS = '' +
    '.clara-panel{background:#faf6ef!important;border:1px solid rgba(200,169,106,.35)!important;border-radius:22px!important;box-shadow:0 30px 70px -20px rgba(13,34,56,.45)!important}' +
    '.clara-header{background:#1a3a5c!important;color:#faf6ef!important;border-bottom:0!important;padding:16px 16px 14px!important;position:relative;overflow:hidden}' +
    '.clara-header::after{content:"";position:absolute;top:-64px;right:-64px;width:140px;height:140px;border-radius:9999px;background:#a94073;opacity:.22;filter:blur(38px);pointer-events:none}' +
    '.clara-title{gap:12px;position:relative;z-index:1}' +
    '.clara-title img{width:44px!important;height:44px!important;border:2px solid #c8a96a;padding:2px;background:#1a3a5c}' +
    '.clara-title strong{font-family:Georgia,"Times New Roman",serif;font-size:19px;font-style:italic;font-weight:500;color:#faf6ef;letter-spacing:.01em}' +
    '.clara-title span{font-size:11px;color:rgba(250,246,239,.62);opacity:1;letter-spacing:.02em}' +
    '.clara-close{background:rgba(255,255,255,.1)!important;color:rgba(250,246,239,.85)!important;border-radius:9999px!important;height:32px!important;width:32px!important;font-size:16px;line-height:1;position:relative;z-index:1;transition:background .2s ease}' +
    '.clara-close:hover{background:rgba(255,255,255,.2)!important}' +
    '.clara-tabs{background:#1a3a5c!important;border-bottom:0!important;padding:0 14px 14px!important;border-radius:0 0 26px 26px;gap:6px}' +
    '.clara-tabs button{border-radius:12px!important;color:rgba(250,246,239,.72)!important;font-weight:600!important;opacity:1!important;padding:7px 10px!important;transition:background .2s ease,color .2s ease}' +
    '.clara-tabs button:hover{background:rgba(255,255,255,.08)!important}' +
    '.clara-tabs button.clara-tab-active{background:#faf6ef!important;color:#1a3a5c!important;border:1px solid rgba(200,169,106,.35);box-shadow:0 2px 6px rgba(13,34,56,.18)!important}' +
    '.clara-quickreplies{background:transparent!important;border-bottom:0!important;padding:12px 14px 4px!important;gap:8px}' +
    '.clara-quickreplies button{background:#fff!important;border:1px solid rgba(200,169,106,.4)!important;color:#1a3a5c!important;padding:7px 14px!important;box-shadow:0 1px 3px rgba(13,34,56,.06);transition:border-color .2s ease,color .2s ease}' +
    '.clara-quickreplies button:hover{background:#fff!important;border-color:#a94073!important;color:#a94073!important}' +
    '.clara-messages{padding:14px!important}' +
    '.clara-empty{padding:34px 12px}' +
    '.clara-empty-avatar{width:76px;height:76px;box-shadow:0 0 0 3px rgba(200,169,106,.45),0 10px 30px -12px rgba(13,34,56,.4)}' +
    '.clara-empty h3{font-family:Georgia,"Times New Roman",serif;font-size:22px;font-style:italic;font-weight:500;color:#1a3a5c}' +
    '.clara-empty p{font-size:13px;color:rgba(26,58,92,.6);opacity:1}' +
    '.clara-suggestions button{border:1px solid rgba(200,169,106,.4)!important;background:#fff!important;border-radius:14px!important;padding:11px 13px!important;color:#1a3a5c!important;box-shadow:0 1px 3px rgba(13,34,56,.06);transition:border-color .2s ease,color .2s ease}' +
    '.clara-suggestions button:hover{border-color:#a94073!important;color:#a94073!important}' +
    '.clara-msg{border-radius:18px;padding:11px 14px;font-size:13.5px;line-height:1.55;box-shadow:0 1px 3px rgba(13,34,56,.06)}' +
    '.clara-msg-user{border-bottom-right-radius:6px}' +
    '.clara-msg-assistant{border:1px solid rgba(200,169,106,.3)!important;border-bottom-left-radius:6px;color:#1a3a5c!important}' +
    '.clara-inputbar{background:transparent!important;border-top:1px solid rgba(200,169,106,.28)!important;padding:12px 14px 14px!important;gap:8px}' +
    '.clara-inputbar input{height:46px!important;border-radius:9999px!important;border:1px solid rgba(200,169,106,.4)!important;padding:0 18px!important;font-size:13.5px!important;color:#1a3a5c!important;box-shadow:0 1px 3px rgba(13,34,56,.05);transition:border-color .2s ease,box-shadow .2s ease}' +
    '.clara-inputbar input:focus{border-color:#a94073!important;box-shadow:0 0 0 3px rgba(169,64,115,.14)!important}' +
    '.clara-send,.clara-mic,.clara-clear{height:40px!important;width:40px!important;border-radius:9999px!important}' +
    '.clara-clear,.clara-mic{background:#fff!important;border:1px solid rgba(200,169,106,.4)!important;color:rgba(26,58,92,.6)!important}' +
    '.clara-send{background:#a94073!important;color:#fff!important;box-shadow:0 6px 16px -6px rgba(169,64,115,.6)!important}' +
    '.clara-send:hover{background:#8e3560!important}' +
    '.clara-quizbanner{border-top:1px solid rgba(200,169,106,.28)!important;border-bottom:0!important}' +
    '.clara-panel.clara-panel-full{border-radius:0!important;border:0!important}' +
    '.clara-options{display:flex;flex-wrap:wrap;gap:8px;margin:2px 0 12px 32px}' +
    '.clara-options button{border:1px solid rgba(200,169,106,.45);background:#fff;color:#1a3a5c;border-radius:12px;padding:8px 12px;font:500 12.5px inherit;cursor:pointer;text-align:left;line-height:1.35;box-shadow:0 1px 3px rgba(13,34,56,.06);transition:border-color .2s ease,color .2s ease}' +
    '.clara-options button:hover{border-color:#a94073;color:#a94073}' +
    '.clara-actions{display:flex;flex-wrap:wrap;gap:8px;margin:6px 0 2px}' +
    '.clara-action-btn{display:inline-block;background:#1a3a5c;color:#fff!important;text-decoration:none!important;border-radius:10px;padding:8px 14px;font:600 12.5px inherit;line-height:1.2;box-shadow:0 2px 8px rgba(13,34,56,.18);transition:background .2s ease,transform .15s ease}' +
    '.clara-action-btn:hover{background:#a94073;transform:translateY(-1px)}' +
    '@media(max-width:640px){.clara-options{margin-left:0}.clara-options button{width:100%}}';

  function ensureStyles() {
    if (document.getElementById('clara-embed-styles')) return;
    var style = document.createElement('style');
    style.id = 'clara-embed-styles';
    style.textContent = '.clara-quizbanner{order:11!important;flex:0 0 auto;display:flex;align-items:center;gap:10px;padding:10px 14px;margin:0;background:linear-gradient(90deg,rgba(169,64,115,.08),rgba(169,64,115,.14));border-top:1px solid rgba(169,64,115,.18);border-bottom:1px solid rgba(169,64,115,.18);color:#a94073;text-decoration:none;font:500 12px -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;cursor:pointer;transition:background .15s ease}.clara-quizbanner:hover{background:linear-gradient(90deg,rgba(169,64,115,.16),rgba(169,64,115,.22))}.clara-quizbanner svg{flex:0 0 auto;color:#a94073}.clara-quizbanner-text{flex:1;line-height:1.35}.clara-quizbanner-cta{font-weight:600;white-space:nowrap}.clara-bubble{position:fixed!important;left:auto!important;right:20px!important;bottom:20px!important;transform:none;display:inline-flex;align-items:center;gap:12px;padding:6px 28px 6px 6px;border-radius:9999px;background:#071739;color:#fff;border:1px solid rgba(212,181,142,.4);cursor:pointer;box-shadow:0 10px 40px -10px rgba(7,23,57,.4);font:14px -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;z-index:2147483645;transition:transform .3s ease,box-shadow .3s ease}.clara-bubble:hover{transform:translateY(-4px);box-shadow:0 15px 50px -12px rgba(7,23,57,.5)}.clara-bubble::before{content:"";position:absolute;inset:0;border-radius:9999px;background:linear-gradient(to bottom right,rgba(255,255,255,.1),transparent);pointer-events:none}.clara-bubble::after{content:"";position:absolute;inset:-1px;border-radius:9999px;background:linear-gradient(to top right,transparent,rgba(212,181,142,.1),rgba(212,181,142,.2));opacity:0;pointer-events:none;transition:opacity .7s ease}.clara-bubble:hover::after{opacity:1}.clara-avatar-wrap{position:relative;display:inline-block;flex:0 0 auto}.clara-avatar-wrap img{width:56px;height:56px;border-radius:9999px;object-fit:cover;display:block;border:1px solid rgba(212,181,142,.5);background:#f4ece1}.clara-status{position:absolute;bottom:2px;right:2px;width:14px;height:14px;border-radius:9999px;background:#a94073;border:3px solid #071739;box-shadow:0 0 12px #a94073,0 0 0 1px rgba(169,64,115,.5)}.clara-launcher-text{display:flex;flex-direction:column;align-items:flex-start}.clara-launcher-meta{display:block;color:#d4b58e;font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:.2em;line-height:1.2;opacity:.8;margin-bottom:2px}.clara-launcher-label{font-family:Georgia,"Times New Roman",serif;font-size:23px;font-style:italic;font-weight:500;line-height:1;color:#fff}.clara-launcher-chevron{width:20px;height:20px;border-radius:9999px;border:1px solid rgba(212,181,142,.3);display:flex;align-items:center;justify-content:center;flex:0 0 auto;transition:background .3s ease,border-color .3s ease}.clara-bubble:hover .clara-launcher-chevron{background:#d4b58e;border-color:#d4b58e}.clara-launcher-chevron svg{width:12px;height:12px;color:#d4b58e;transition:color .3s ease}.clara-bubble:hover .clara-launcher-chevron svg{color:#1a3a5c}.clara-panel{position:fixed!important;left:auto!important;right:20px!important;bottom:20px!important;transform:none;z-index:2147483646;width:calc(100vw - 16px);max-width:420px;height:min(720px,calc(100dvh - 40px));background:#F6F1E8;border:1px solid rgba(0,0,0,.08);border-radius:16px;box-shadow:0 22px 60px rgba(0,0,0,.28);overflow:hidden;display:none;flex-direction:column;font:14px -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;color:#0d2238}.clara-header{order:1;flex:0 0 auto;display:flex;align-items:center;justify-content:space-between;padding:12px 16px;border-bottom:1px solid rgba(0,0,0,.08);background:#F6F1E8}.clara-title{display:flex;align-items:center;gap:10px}.clara-title img{width:32px;height:32px;border-radius:9999px;object-fit:cover}.clara-title strong{display:block;font-size:14px}.clara-title span{display:block;font-size:11px;opacity:.6}.clara-close,.clara-clear{border:0;background:rgba(0,0,0,.06);border-radius:8px;color:#0d2238;cursor:pointer;height:30px;width:30px}.clara-tabs{order:2;flex:0 0 auto;display:flex;gap:4px;padding:8px 12px;border-bottom:1px solid rgba(0,0,0,.08);background:#F6F1E8;overflow-x:auto}.clara-tabs button{flex:1;min-width:0;border:0;background:transparent;color:#0d2238;padding:6px 10px;border-radius:8px;font:500 12px inherit;cursor:pointer;opacity:.65;white-space:nowrap}.clara-tabs button.clara-tab-active{background:#fff;opacity:1;box-shadow:0 1px 2px rgba(0,0,0,.06)}.clara-quickreplies{order:3;flex:0 0 auto;display:flex;flex-wrap:wrap;gap:6px;padding:8px 12px;border-bottom:1px solid rgba(0,0,0,.08);background:#F6F1E8}.clara-quickreplies button{border:1px solid rgba(169,64,115,.3);background:#fff;color:#a94073;border-radius:9999px;padding:6px 12px;font:500 12px inherit;cursor:pointer}.clara-quickreplies button:hover{background:#a94073;color:#fff}.clara-messages{order:4;flex:1 1 0;min-height:0;overflow:auto;padding:12px;scrollbar-width:none}.clara-messages::-webkit-scrollbar{display:none}.clara-empty{text-align:center;padding:28px 10px}.clara-empty-avatar{width:64px;height:64px;border-radius:9999px;object-fit:cover;box-shadow:0 0 0 4px rgba(0,0,0,.06);margin:0 auto 14px}.clara-empty h3{font-size:18px;margin:0 0 6px}.clara-empty p{font-size:12px;line-height:1.5;opacity:.65;margin:0 auto 18px;max-width:300px}.clara-suggestions{display:grid;grid-template-columns:1fr 1fr;gap:8px}.clara-suggestions button{border:1px solid rgba(0,0,0,.12);background:rgba(255,255,255,.6);border-radius:12px;padding:10px;text-align:left;color:#0d2238;font:500 12px inherit;cursor:pointer}.clara-row{display:flex;gap:8px;margin:0 0 12px}.clara-row-user{justify-content:flex-end}.clara-row-assistant{align-items:flex-start}.clara-msg-avatar{width:24px;height:24px;border-radius:9999px;object-fit:cover;flex:0 0 auto}.clara-msg{max-width:82%;border-radius:14px;padding:10px 12px;font-size:13px;line-height:1.45}.clara-msg-user{background:#a94073;color:#fff;white-space:pre-wrap}.clara-msg-assistant{background:#fff;border:1px solid rgba(0,0,0,.08);color:#0d2238}.clara-msg-assistant a{color:#a94073;text-decoration:underline}.clara-feedback{display:flex;gap:4px;margin:4px 0 0 4px}.clara-feedback button{border:0;background:transparent;opacity:.55;cursor:pointer;font-size:12px}.clara-inputbar{order:10!important;flex:0 0 auto;display:flex;align-items:center;gap:8px;padding:10px 12px;border-top:1px solid rgba(0,0,0,.08);background:#F6F1E8}.clara-inputbar input{flex:1;height:36px;border-radius:10px;border:1px solid rgba(0,0,0,.1);background:#fff;padding:0 12px;outline:none;color:#0d2238;font:13px inherit}.clara-send,.clara-mic{height:36px;width:36px;border:0;border-radius:10px;background:rgba(0,0,0,.06);color:#0d2238;cursor:pointer;display:flex;align-items:center;justify-content:center;flex:0 0 auto}.clara-send{background:#a94073;color:#fff}.clara-mic.clara-mic-recording{background:#dc2626;color:#fff;animation:clara-pulse 1.2s ease-in-out infinite}.clara-mic[disabled]{opacity:.6;cursor:wait}@keyframes clara-pulse{0%,100%{box-shadow:0 0 0 0 rgba(220,38,38,.6)}50%{box-shadow:0 0 0 6px rgba(220,38,38,0)}}.clara-typing{display:flex;gap:4px;align-items:center;height:34px}.clara-typing span{width:6px;height:6px;border-radius:50%;background:rgba(0,0,0,.4);animation:clara-bounce 1s infinite}.clara-typing span:nth-child(2){animation-delay:.15s}.clara-typing span:nth-child(3){animation-delay:.3s}@keyframes clara-bounce{0%,80%,100%{transform:translateY(0)}40%{transform:translateY(-4px)}}.clara-panel.clara-panel-full{left:0!important;right:0!important;top:0!important;bottom:0!important;transform:none;width:100vw;max-width:100vw;height:100dvh;border-radius:0;border:0}.clara-panel.clara-panel-full .clara-messages{max-width:760px;width:100%;margin:0 auto}.clara-panel.clara-panel-full .clara-inputbar{justify-content:center}.clara-panel.clara-panel-full .clara-inputbar input{max-width:720px}@media(max-width:640px){.clara-panel{left:8px!important;right:8px!important;top:8px!important;bottom:8px!important;width:auto!important;max-width:none!important;height:auto!important;border-radius:16px}.clara-panel.clara-kb-open .clara-quickreplies{display:none}.clara-suggestions{grid-template-columns:1fr}.clara-quickreplies{flex-wrap:nowrap;overflow-x:auto;-webkit-overflow-scrolling:touch}.clara-quickreplies button{flex:0 0 auto}.clara-inputbar input{font-size:16px}.clara-msg{font-size:14px}.clara-bubble:not(.clara-bubble-compact){right:16px!important;bottom:16px!important;padding:5px!important;gap:0!important}.clara-bubble:not(.clara-bubble-compact) .clara-launcher-chevron{display:none!important}.clara-bubble:not(.clara-bubble-compact){padding:5px 16px 5px 5px!important;gap:10px!important}.clara-bubble:not(.clara-bubble-compact) .clara-avatar-wrap img{width:44px;height:44px}.clara-bubble:not(.clara-bubble-compact) .clara-launcher-meta{display:none!important}.clara-bubble:not(.clara-bubble-compact) .clara-launcher-label{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;font-style:normal;font-weight:600;font-size:14px;letter-spacing:.01em}}.clara-bubble.clara-bubble-compact{flex-direction:column;align-items:flex-end;gap:8px;padding:0;background:transparent;border:0;box-shadow:none;backdrop-filter:none}.clara-bubble.clara-bubble-compact::before,.clara-bubble.clara-bubble-compact::after{display:none}.clara-bubble.clara-bubble-compact:hover{transform:translateY(-1px)}.clara-compact-pill{display:inline-flex;align-items:center;gap:6px;padding:8px 16px;border-radius:9999px;background:rgba(246,241,232,.75);border:1px solid rgba(0,0,0,.06);color:#5c5347;font-size:13px;font-weight:400;letter-spacing:.01em;box-shadow:0 2px 8px -2px rgba(0,0,0,.08);backdrop-filter:blur(8px);transition:background .2s ease,color .2s ease}.clara-compact-pill svg{width:13px;height:13px;color:#8a7f70;flex:0 0 auto;transition:color .2s ease}.clara-compact-circle{display:flex;align-items:center;justify-content:center;width:52px;height:52px;border-radius:9999px;background:#f4efe6;border:1px solid rgba(0,0,0,.08);color:#8a6f4d;box-shadow:0 6px 18px -4px rgba(0,0,0,.2);transition:transform .2s ease,box-shadow .2s ease}.clara-compact-circle svg{width:20px;height:20px}.clara-bubble.clara-bubble-compact:hover .clara-compact-pill{background:rgba(246,241,232,.92);color:#1a3a5c}.clara-bubble.clara-bubble-compact:hover .clara-compact-pill svg{color:#1a3a5c}.clara-bubble.clara-bubble-compact:hover .clara-compact-circle{transform:translateY(-1px);box-shadow:0 8px 22px -4px rgba(0,0,0,.24)}' + CLARA_LUXE_CSS;
    document.head.appendChild(style);
  }

  function ensurePanel() {
    if (panelEl) return;
    ensureStyles();
    panelEl = document.createElement('div');
    panelEl.className = 'clara-panel';
    panelEl.setAttribute('data-clara-panel', '');
    panelEl.setAttribute('data-clara-build', BUILD_MARKER);
    panelEl.innerHTML = '<div class="clara-header"><div class="clara-title"><img src="' + avatarUrl + '" alt="Clara" /><div><strong>Clara</strong><span>Online . Ready to help</span></div></div><button class="clara-close" type="button" aria-label="Close">×</button></div><div class="clara-tabs"><button type="button" data-clara-tab="subscriptions" class="clara-tab-active">Subs</button><button type="button" data-clara-tab="returns">Returns</button><button type="button" data-clara-tab="tracking">Tracking</button></div><div class="clara-quickreplies"></div><div class="clara-messages" data-clara-messages></div><div class="clara-inputbar" data-clara-inputbar><button class="clara-clear" type="button" title="Clear chat" aria-label="Clear chat">⌫</button><input type="text" name="clara-question" aria-label="Ask Clara" placeholder="Ask Clara anything..." autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" data-form-type="other" data-lpignore="true" data-1p-ignore="true" data-bwignore="true" /><button class="clara-mic" type="button" aria-label="Voice input" title="Voice input"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg></button><button class="clara-send" type="button" aria-label="Send"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg></button></div><a class="clara-quizbanner" data-clara-quizbanner href="' + QUIZ_PATH + '" target="_top" rel="noopener"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="2" width="8" height="4" rx="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="M9 12l2 2 4-4"/></svg><span class="clara-quizbanner-text">Not sure where to start? Take the 2-minute health quiz.</span><span class="clara-quizbanner-cta">Start &rarr;</span></a>';
    document.body.appendChild(panelEl);
    messagesEl = panelEl.querySelector('.clara-messages');
    tabsEl = panelEl.querySelector('.clara-tabs');
    quickEl = panelEl.querySelector('.clara-quickreplies');
    inputEl = panelEl.querySelector('input');
    clearBtn = panelEl.querySelector('.clara-clear');
    micBtn = panelEl.querySelector('.clara-mic');
    panelEl.querySelector('.clara-close').addEventListener('click', function () { setOpen(false); });
    var quizBanner = panelEl.querySelector('.clara-quizbanner');
    if (quizBanner) quizBanner.addEventListener('click', function (event) {
      track('quiz_banner_clicked', { surface: 'bubble' });
      if (window.__claraQuizModal && typeof window.__claraQuizModal.open === 'function') {
        event.preventDefault();
        window.__claraQuizModal.open(claraIdentity());
      }
    });
    panelEl.querySelector('.clara-send').addEventListener('click', function () { send(inputEl.value, 'bubble'); });
    inputEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); send(inputEl.value, 'bubble'); } });
    clearBtn.addEventListener('click', function () { messages = []; replyOptions = []; conversationId = undefined; renderMessages(); });
    micBtn.addEventListener('click', function () { toggleRecording(); });
    tabsEl.addEventListener('click', function (e) {
      var t = e.target && e.target.getAttribute && e.target.getAttribute('data-clara-tab');
      if (!t) return;
      activeTab = t;
      renderMessages();
      renderQuickReplies();
    });
    quickEl.addEventListener('click', function (e) {
      var prompt = e.target && e.target.getAttribute && e.target.getAttribute('data-clara-quick');
      if (prompt) send(prompt, 'tab_' + activeTab);
    });
    messagesEl.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.getAttribute) return;
      var suggestion = target.getAttribute('data-clara-suggestion');
      if (suggestion) send(suggestion, 'bubble');
      var option = target.getAttribute('data-clara-option');
      if (option) send(option, 'reply_option');

      var feedback = target.getAttribute('data-clara-feedback');
      if (feedback) track(feedback === 'up' ? 'thumbs_up' : 'thumbs_down', { message_index: Number(target.getAttribute('data-index') || 0) });
    });
    enforceInputBeforeQuiz();
    ensureOrderObserver();
  }

  function enforceInputBeforeQuiz() {
    var panels = panelEl ? [panelEl] : Array.prototype.slice.call(document.querySelectorAll('[data-clara-panel],.clara-panel'));
    panels.forEach(function (panel) {
      var messagesNode = panel.querySelector('[data-clara-messages],.clara-messages');
      var input = panel.querySelector('[data-clara-inputbar],.clara-inputbar');
      var banner = panel.querySelector('[data-clara-quizbanner],.clara-quizbanner');
      if (!input || !banner) return;
      if (messagesNode && messagesNode.nextElementSibling !== input) panel.insertBefore(input, messagesNode.nextSibling);
      if (input.nextElementSibling !== banner) panel.insertBefore(banner, input.nextSibling);
    });
  }

  function ensureOrderObserver() {
    if (!panelEl || orderObserver || !window.MutationObserver) return;
    orderObserver = new MutationObserver(enforceInputBeforeQuiz);
    orderObserver.observe(panelEl, { childList: true });
  }

  var bubbleCompact = false;

  function renderBubble() {
    if (!bubbleEl) return;
    if (bubbleCompact) {
      bubbleEl.classList.add('clara-bubble-compact');
      bubbleEl.innerHTML = '<span class="clara-compact-pill"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.9 5.8L20 11l-6.1 2.2L12 19l-1.9-5.8L4 11l6.1-2.2z"/></svg><span>Need more help?</span></span><span class="clara-compact-circle"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></span>';
    } else {
      bubbleEl.classList.remove('clara-bubble-compact');
      bubbleEl.innerHTML = '<span class="clara-avatar-wrap"><img src="' + avatarUrl + '" alt="Clara" /><span class="clara-status"></span></span><span class="clara-launcher-text"><span class="clara-launcher-meta">Live Wellness Support</span><span class="clara-launcher-label">Ask Clara</span></span><span class="clara-launcher-chevron"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></span>';
    }
  }

  function mountBubble() {
    ensureStyles();
    bubbleEl = document.createElement('button');
    bubbleEl.type = 'button';
    bubbleEl.className = 'clara-bubble';
    bubbleEl.setAttribute('data-clara-build', BUILD_MARKER);
    bubbleEl.setAttribute('aria-label', 'Ask Clara');
    renderBubble();
    bubbleEl.addEventListener('click', function () { setOpen(true); });
    document.body.appendChild(bubbleEl);

    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var shouldCompact = (window.scrollY || window.pageYOffset || 0) > 240;
        if (shouldCompact !== bubbleCompact) {
          bubbleCompact = shouldCompact;
          renderBubble();
        }
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function mountLegacyHeroSlots() {
    document.querySelectorAll('[data-clara-hero]:not([hidden])').forEach(function (slot) {
      if (slot.__claraBound) return;
      slot.__claraBound = true;
      var form = document.createElement('form');
      form.style.cssText = 'display:flex;align-items:center;gap:8px;background:#fff;border:1px solid rgba(0,0,0,.1);border-radius:9999px;padding:8px 8px 8px 20px;max-width:560px;width:100%;margin:0 auto;box-shadow:0 8px 24px rgba(0,0,0,.12)';
      form.innerHTML = '<input type="text" name="clara-question" aria-label="Ask Clara" placeholder="How can I help you today?" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" data-form-type="other" data-lpignore="true" data-1p-ignore="true" data-bwignore="true" style="flex:1;border:0;outline:0;background:transparent;font:inherit;font-size:15px;color:#111" /><button type="submit" aria-label="Ask Clara" style="border:0;background:#1a3a5c;color:#fff;border-radius:9999px;width:40px;height:40px;display:inline-flex;align-items:center;justify-content:center;cursor:pointer"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg></button>';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input');
        var value = input && input.value;
        setOpen(true, true);
        if (value) send(value, 'hero');
        if (input) input.value = '';
      });
      slot.appendChild(form);
    });
  }

  function mountNavPill() {
    var slot = document.querySelector('[data-clara-nav]');
    if (!slot || slot.__claraBound) return;
    slot.__claraBound = true;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Ask Clara');
    btn.style.cssText = 'display:inline-flex;align-items:center;gap:6px;padding:8px 16px;border-radius:9999px;border:1px solid currentColor;background:transparent;font:inherit;font-size:14px;cursor:pointer;color:inherit';
    btn.innerHTML = '<span>Ask Clara</span>';
    btn.addEventListener('click', function () { setOpen(true); track('overlay_opened', { surface: 'nav' }); });
    slot.appendChild(btn);
  }

  function hookCart() {
    try {
      var origFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = origFetch.apply(this, arguments);
        if (/\/cart\/add(\.js)?($|\?)/.test(url)) {
          p.then(function (r) { try { r.clone().json().then(function (data) { track('add_to_cart', { source: 'fetch', data: data }); }); } catch (e) {} });
        }
        return p;
      };
    } catch (e) {}
  }

  function init() {
    ensureSandbox();
    mountBubble();
    mountLegacyHeroSlots();
    mountNavPill();
    hookCart();
    enforceInputBeforeQuiz();
    refreshStarters();
    track('embed_loaded');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.Clara = {
    open: function (opts) {
      var full = !!(opts && (opts.fullscreen || opts.surface === 'hero'));
      setOpen(true, full);
      enforceInputBeforeQuiz();
      if (opts && opts.seed) send(opts.seed, opts.surface || 'bubble');
    },
    close: function () { setOpen(false); },
    isOpen: function () { return panelEl && panelEl.style.display !== 'none'; },
    anonId: anonId,
    track: track,
  };
})();